import Accordion from 'components/Accordion';
import { LayoutContainer } from 'components/Layout';
import RichText from 'components/RichText';
import Text from 'components/Text';
import type { Field, HeadingLevel } from 'models/sitecore';

interface Item {
	content: string;
	heading: string;
}

interface Props {
	className?: string;
	heading?: Field<string>;
	headingLevel?: HeadingLevel;
	items: Item[];
}

/** Accordions with an optional heading. */
export default function BlockAccordion({
	className,
	heading,
	headingLevel = 'h2',
	items,
}: Props) {
	return (
		<LayoutContainer outerClassName={className}>
			<div className="relative max-w-col-6">
				<Text as={headingLevel} field={heading} className="mb-r-md" />
				{items.map((item) => (
					<Accordion key={item.heading} title={item.heading} size="medium">
						<RichText
							html={item.content}
							inheritStyle
							className="py-1 md:py-3"
						/>
					</Accordion>
				))}
			</div>
		</LayoutContainer>
	);
}
BlockAccordion.displayName = 'BlockAccordion';
